import FloatingFormItem from '@/components/_common/FloatingFormItem';
import InputDecimal from '@/components/_common/InputDecimal';
import { Row, Col, Form, Segmented, Checkbox, InputNumber } from 'antd';
import { useLabelPrintingContext } from '../..';
import {
  LabelPrintingLayoutAlign,
  LabelPrintingLayoutVerticalAlign,
} from '../../types';

export default function LabelPrintingToolbarContentPanel() {
  const { form } = useLabelPrintingContext();
  const descriptionWithLineClamp = Form.useWatch(
    ['layout', 'descriptionWithLineClamp'],
    form,
  );

  return (
    <>
      <Row gutter={[16, 0]}>
        <Col span={24}>
          <span className="print-page-toolbar-label">
            Alinhamento horizontal
          </span>
          <Form.Item name={['layout', 'align']}>
            <Segmented
              className="print-page-toolbar-segmented"
              style={{ width: '100%' }}
              options={[
                {
                  value: LabelPrintingLayoutAlign.left,
                  label: 'Esquerda',
                },
                {
                  value: LabelPrintingLayoutAlign.center,
                  label: 'Centro',
                },
                {
                  value: LabelPrintingLayoutAlign.right,
                  label: 'Direita',
                },
              ]}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <span className="print-page-toolbar-label">Alinhamento vertical</span>
          <Form.Item name={['layout', 'verticalAlign']}>
            <Segmented
              className="print-page-toolbar-segmented"
              style={{ width: '100%' }}
              options={[
                {
                  value: LabelPrintingLayoutVerticalAlign.start,
                  label: 'Superior',
                },
                {
                  value: LabelPrintingLayoutVerticalAlign.center,
                  label: 'Centro',
                },
                {
                  value: LabelPrintingLayoutVerticalAlign.end,
                  label: 'Inferior',
                },
              ]}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name={['layout', 'descriptionWithLineClamp']}
            initialValue={false}
            valuePropName="checked"
            style={{ margin: 0 }}
          >
            <Checkbox>Cortar descrição automáticamente</Checkbox>
          </Form.Item>
        </Col>

        <Col span={24} sm={12}>
          <FloatingFormItem name={['layout', 'fontSize']} label="Fonte">
            <InputDecimal style={{ width: '100%' }} />
          </FloatingFormItem>
        </Col>

        <Col span={24} sm={12}>
          <FloatingFormItem
            name={['layout', 'maxLenghtDescription']}
            label="Máx. descrição"
          >
            <InputNumber
              style={{ width: '100%' }}
              disabled={descriptionWithLineClamp}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name={['layout', 'contentCols']}
            label="Colunas do conteúdo"
          >
            <InputNumber style={{ width: '100%' }} min={1} />
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
}
